import { render } from "./SyllabusMaster.vue?vue&type=template&id=65d8132e&scoped=true"
import script from "./SyllabusMaster.vue?vue&type=script&lang=js"
export * from "./SyllabusMaster.vue?vue&type=script&lang=js"

import "./SyllabusMaster.vue?vue&type=style&index=0&id=65d8132e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d8132e"]])

export default __exports__